// extracted by mini-css-extract-plugin
export default {"wrap":"KG-z","subtitle":"LG-z","contentWrap":"MG-z","imgWrap":"NG-z","heading":"OG-z","copy":"PG-z"};